import React from "react";
import "../../components/DashboardModule/NotVerifiedModal.css";
import logostelmart from '../../assets/images/logostelmart.png';
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from 'react-router-dom';

const EnquiryModal = ({ onClose }) => {
    const navigate = useNavigate(); 

    const handleGoToDashboard = () => {
        navigate('/dashboard'); 
    };

    return (
        <div className="notModal-overlay">
            <div className="notModal">
                <button className="notModal-close" onClick={onClose}>
                    <RxCross2 />
                </button>
                <img
                    src={logostelmart}
                    alt="Logo Stelmart"
                    className="notModal-logo"
                />
                <p className="notModal-text font-poppins">
                    Enquiry has been placed!
                    You can check your quotations right
                    now
                </p>
                <button 
                    className="notModal-button font-poppins" 
                    onClick={handleGoToDashboard}
                >
                    Go to My Dashboard
                </button>
            </div>
        </div>
    );
};

export default EnquiryModal;
